import {repositoryTreePath} from '@github-ui/paths'
import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'
import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'
import type {Commit} from '@github-ui/repos-types'

import type {CodeViewPathParams} from './types/shared-query-types'

export const treeCommitInfoQuery = {
  queryName: 'treeCommitInfo' as const,
  queryDeps: ({params: routeParams}: {params: Record<string, string | undefined>}) => {
    const params = routeParams as CodeViewPathParams

    return {
      pathname: repositoryTreePath({
        repo: {
          ownerLogin: params.owner,
          name: params.repo,
        },
        commitish: params.branch,
        path: params['*'],
        action: 'tree-commit-info',
      }),
    }
  },
  queryFn: async (queryKey: {queryDeps: {pathname: string}}) => queryFnFetch<Record<string, Commit>>(queryKey),
  type: QueryRouteQueryType.Deferred,
}
